export default __webpack_public_path__ + "static/media/banner.3cab0294.jpg";